import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { LawyeredActions } from "./index";
import {
  CLEAR_LAWYERED_CHALLAN,
  CLEAR_LAWYERED_CHALLAN_LIST_STATE,
  FETCH_LAWYERED_CHALLAN_FAILED,
  FETCH_LAWYERED_CHALLAN_LIST_FAILED,
  FETCH_LAWYERED_CHALLAN_LIST_PROGRESS,
  FETCH_LAWYERED_CHALLAN_LIST_SUCCESS,
  FETCH_LAWYERED_CHALLAN_PROGRESS,
  FETCH_LAWYERED_CHALLAN_SUCCESS,
} from "./lawyered.action";
import { initialLawyeredState } from "./lawyered.state";

export const lawyeredReducer = (
  state: IStoreState["lawyered"] = initialLawyeredState,
  action: LawyeredActions
) => {
  switch (action.type) {
    // ==================== LAWYERED CHALLAN REDUCERS ====================
    case FETCH_LAWYERED_CHALLAN_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.lawyeredChallan.list.loading = LoadState.InProgress;
        draftState.lawyeredChallan.list.error = null;
      });
    }

    case FETCH_LAWYERED_CHALLAN_LIST_SUCCESS: {
      return produce(state, (draftState) => {
        draftState.lawyeredChallan.list.loading = LoadState.Loaded;
        draftState.lawyeredChallan.list.list = action.payload.list;
        draftState.lawyeredChallan.list.totalRecords = action.payload.totalRecords;
        draftState.lawyeredChallan.list.error = null;
      });
    }

    case FETCH_LAWYERED_CHALLAN_LIST_FAILED: {
      return produce(state, (draftState) => {
        draftState.lawyeredChallan.list.loading = LoadState.Failed;
        draftState.lawyeredChallan.list.error = "Failed to load lawyered challan list";
      });
    }

    case CLEAR_LAWYERED_CHALLAN_LIST_STATE: {
      return produce(state, (draftState) => {
        draftState.lawyeredChallan.list = initialLawyeredState.lawyeredChallan.list;
      });
    }

    case FETCH_LAWYERED_CHALLAN_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.lawyeredChallan.data.loading = LoadState.InProgress;
        draftState.lawyeredChallan.data.error = null;
      });
    }

    case FETCH_LAWYERED_CHALLAN_SUCCESS: {
      return produce(state, (draftState) => {
        draftState.lawyeredChallan.data.loading = LoadState.Loaded;
        draftState.lawyeredChallan.data.data = action.payload.challan;
        draftState.lawyeredChallan.data.error = null;
      });
    }

    case FETCH_LAWYERED_CHALLAN_FAILED: {
      return produce(state, (draftState) => {
        draftState.lawyeredChallan.data.loading = LoadState.Failed;
        draftState.lawyeredChallan.data.error = action.payload.errorMessage;
      });
    }

    case CLEAR_LAWYERED_CHALLAN: {
      return produce(state, (draftState) => {
        draftState.lawyeredChallan.data = initialLawyeredState.lawyeredChallan.data;
      });
    }

    default:
      return state;
  }
};
